export class Messages {
    static pointsEarnedWhenLikeMessage(remainingPoints: number): string {
        return 'Congratulations! You\'ve earned 2 A-Points. There\'s ' + remainingPoints +
            ' turn(s) remaining to get more points when like or comment';
    }
}
